/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SearchClassifyResponseClassifiersItem0 } from './searchClassifyResponseClassifiersItem0';
import type { SearchClassifyResponseClassifiersItem1 } from './searchClassifyResponseClassifiersItem1';
import type { SearchClassifyResponseClassifiersItem2 } from './searchClassifyResponseClassifiersItem2';
import type { SearchClassifyResponseClassifiersItem3 } from './searchClassifyResponseClassifiersItem3';
import type { SearchClassifyResponseClassifiersItem4 } from './searchClassifyResponseClassifiersItem4';

export interface SearchClassifyResponse {
  /**
     * [location, job_title, years_of_experience, industry, skills]
     * @minItems 5
     * @maxItems 5
     */
  classifiers: [SearchClassifyResponseClassifiersItem0, SearchClassifyResponseClassifiersItem1, SearchClassifyResponseClassifiersItem2, SearchClassifyResponseClassifiersItem3, SearchClassifyResponseClassifiersItem4];
}
